import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "skiRack"
const SkiRackIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M7.71 1.54C9.154 1.413 10.428 2.482 10.554 3.926L11.234 11.706 13.378 3.714C13.752 2.314 15.191 1.482 16.592 1.857S18.822 3.672 18.448 5.073L14.009 21.638C13.834 22.29 13.162 22.679 12.509 22.504L11.39 22.204C11.253 22.277 11.099 22.325 10.935 22.339L8.146 22.582C7.472 22.641 6.878 22.142 6.819 21.468L5.324 4.384C5.198 2.939 6.266 1.666 7.71 1.54M7.995 17.702 8.29 21.064 10.53 20.867 10.236 17.506zM12.031 20.823 12.631 20.986 13.504 17.724 11.72 17.246zM11.72 15.694 13.894 16.275 14.766 13.015 12.593 12.433zM7.57 12.845 7.865 16.207 10.105 16.012 9.812 12.649zM16.204 3.307C15.603 3.147 14.987 3.502 14.826 4.102L12.98 10.984 15.155 11.566 16.999 4.685C17.159 4.085 16.804 3.468 16.203 3.307M7.841 3.034C7.22 3.09 6.764 3.634 6.818 4.254L7.44 11.35 9.68 11.155 9.06 4.057C9.004 3.437 8.46 2.98 7.84 3.034"
            clipRule="evenodd"
          />
          <path d="M3.75 19.5H4.5V21H3.75V22.5H2.25V21H1.5V19.5H2.25V1.5H3.75zM21.75 19.5H22.5V21H21.75V22.5H20.25V21H19.5V19.5H20.25V1.5H21.75z" />
        </svg>
      }
    </span>
  )
}
export default SkiRackIcon
